/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { collectExtraKeys as collectExtraKeys$ } from "../../lib/schemas.js";
import { OutpostError } from "./outposterror.js";

/**
 * Status codes relating to the client being rate limited by the server
 */
export type RateLimitedErrorData = {
  message?: string | undefined;

  additionalProperties: { [k: string]: any };
};

/**
 * Status codes relating to the client being rate limited by the server
 */
export class RateLimitedError extends OutpostError {
  additionalProperties: { [k: string]: any } = {};

  /** The original data that was passed to this error instance. */
  data$: RateLimitedErrorData;

  constructor(
    err: RateLimitedErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    if (err.additionalProperties != null) {
      this.additionalProperties = err.additionalProperties;
    }

    this.name = "RateLimitedError";
  }
}

/** @internal */
export const RateLimitedError$inboundSchema: z.ZodType<
  RateLimitedError,
  z.ZodTypeDef,
  unknown
> = collectExtraKeys$(
  z.object({
    message: z.string().optional(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .catchall(z.any()),
  "additionalProperties",
  false,
)
  .transform((v) => {
    return new RateLimitedError(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type RateLimitedError$Outbound = {
  message?: string | undefined;
  [additionalProperties: string]: unknown;
};

/** @internal */
export const RateLimitedError$outboundSchema: z.ZodType<
  RateLimitedError$Outbound,
  z.ZodTypeDef,
  RateLimitedError
> = z.instanceof(RateLimitedError)
  .transform(v => v.data$)
  .pipe(
    z.object({
      message: z.string().optional(),
      additionalProperties: z.record(z.any()),
    }).transform((v) => {
      return {
        ...v.additionalProperties,
        ...remap$(v, {
          additionalProperties: null,
        }),
      };
    }),
  );
